import { Callout } from '@studio/design-system/callout';
import { twMerge } from 'cn';

/** LimitExceeded. */
export const LimitExceeded = ({ className }: { className?: string }) => (
  <Callout className={className} severity='info' title='Collaborator limit reached'>
    <Callout.P className='text-foreground'>
      <span className='px-4 text-primary'>Upgrade your plan</span> to invite more users.
    </Callout.P>
  </Callout>
);

/** RoundedProfile. */
export const RoundedProfile = ({
  children,
  className
}: {
  children?: React.ReactNode;
  className?: string;
}) => (
  <div
    className={twMerge(
      'flex h-28 w-28 items-center justify-center rounded-full bg-primary text-white',
      className
    )}
  >
    {children}
  </div>
);
